import React, { useCallback, useEffect, useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
const purchases = [{
  name: 'Mauricio Gómez',
  country: 'Estados Unidos'
}, {
  name: 'Carlos Mendoza',
  country: 'México'
}, {
  name: 'Andrés Herrera',
  country: 'Colombia'
}, {
  name: 'Roberto Silva',
  country: 'Brasil'
}, {
  name: 'Diego Fernández',
  country: 'Argentina'
}, {
  name: 'Luis Ramírez',
  country: 'España'
}, {
  name: 'Jorge Castillo',
  country: 'Chile'
}, {
  name: 'Fernando López',
  country: 'Perú'
}, {
  name: 'Miguel Ángel Torres',
  country: 'Ecuador'
}, {
  name: 'Alejandro Ruiz',
  country: 'Venezuela'
}, {
  name: 'Sebastián Morales',
  country: 'Costa Rica'
}, {
  name: 'Héctor Vargas',
  country: 'Panamá'
}, {
  name: 'Ricardo Peña',
  country: 'República Dominicana'
}, {
  name: 'Javier Ortega',
  country: 'Guatemala'
}, {
  name: 'Pablo Navarro',
  country: 'Honduras'
}, {
  name: 'Óscar Delgado',
  country: 'El Salvador'
}, {
  name: 'Raúl Jiménez',
  country: 'Uruguay'
}, {
  name: 'Emilio Sánchez',
  country: 'Bolivia'
}, {
  name: 'Nicolás Aguilar',
  country: 'Paraguay'
}, {
  name: 'Tomás Reyes',
  country: 'Nicaragua'
}];
function getTimeAgo(): string {
  const mins = Math.floor(Math.random() * 12) + 1;
  return `hace ${mins} min`;
}
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(() => Math.floor(Math.random() * purchases.length));
  const [timeAgo, setTimeAgo] = useState(getTimeAgo);
  const showNotification = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % purchases.length);
    setTimeAgo(getTimeAgo());
    setVisible(true);
    setTimeout(() => setVisible(false), 4000);
  }, []);
  useEffect(() => {
    // First notification after 15 seconds
    const initialTimeout = setTimeout(showNotification, 15000);
    // Then every 20 seconds
    const interval = setInterval(showNotification, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [showNotification]);
  const purchase = purchases[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-[320px] transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-440">
      <div className="bg-[#1A1D24] border border-white/10 rounded-lg shadow-[0_8px_30px_rgba(0,0,0,0.4)] p-3 flex items-start gap-3" data-id="element-441">
        {/* Icon */}
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-emerald-500/20 flex items-center justify-center" data-id="element-442">
          <CheckCircleIcon className="w-5 h-5 text-emerald-400" data-id="element-443" />
        </div>
        {/* Content */}
        <div className="flex-1 min-w-0" data-id="element-444">
          <p className="text-white text-sm font-semibold leading-tight truncate" data-id="element-445">
            {purchase.name}
          </p>
          <p className="text-gray-400 text-xs mt-0.5" data-id="element-446">
            {purchase.country} · {timeAgo}
          </p>
          <p className="text-emerald-400 text-xs font-medium mt-1" data-id="element-447">
            Compró el Sistema Completo ⚡
          </p>
        </div>
        {/* Close */}
        <button onClick={() => setVisible(false)} className="flex-shrink-0 text-gray-500 hover:text-gray-300 text-lg leading-none mt-0.5 bg-transparent border-none cursor-pointer p-0" aria-label="Cerrar" data-id="element-448">
          ×
        </button>
      </div>
    </div>;
}